import * as React from 'react';

import './campaign-payouts-list-summary.scss';

type SummaryData = {
  [x: string]: {
    label: string,
    total: number | string
  }
};

type Props = {
  data: SummaryData
};

const CampaignPayoutsListSummary = (
  {
    data
  }: Props
): JSX.Element => (
  <section
    className="campaign-payouts-list-summary"
    data-qa="campaign-payouts-list-summary"
  >
    {
      Object.keys(data).map(item => {
        const itemData = data[item];

        return (
          <div
            key={`campaign-payouts-list-summary-${item}`}
            className="campaign-payouts-list-summary__section"
          >
            <div className="campaign-payouts-list-summary__title">
              {itemData.label}
            </div>
            {itemData.total}
          </div>
        );
      })
    }
  </section>
);

export default CampaignPayoutsListSummary;
